import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Table, TBody, TR, TD } from 'oy-vey';
import Layout from '../layouts/Layout';
import Header from '../modules/Header';
import Footer from '../modules/Footer';
import EmptySpace from '../modules/EmptySpace';
import EmailSignature from './EmailSignature';
import CurrencyView from '../modules/CurrencyView';
import { PRIMARY_COLOR } from '../../../constants';
import { textStyle } from '../../../helpers/getEmailStyles';
//Helper
import { getDateUsingTimeZone } from '../../../helpers/dateRange';
class CancelledByHost extends Component {
	static propTypes = {
		content: PropTypes.shape({
			hostName: PropTypes.string.isRequired,
			guestName: PropTypes.string.isRequired,
			checkIn: PropTypes.string.isRequired,
			confirmationCode: PropTypes.number.isRequired,
			listTitle: PropTypes.string.isRequired,
			refundToGuest: PropTypes.number.isRequired,
			currency: PropTypes.string.isRequired
		}).isRequired
	};

	static defaultProps = {
		content: {
			refundToGuest: 0
		}
	};

	render() {
		const { content: { guestName, hostName, confirmationCode, checkIn, listTitle, refundToGuest, currency, logo, country, siteName } } = this.props;
		let checkInDate = checkIn != null ? moment(checkIn).format('DD-MM-YYYY h:mm A') : '',
			momentStartDate = moment(checkIn).startOf('day');
		let today = getDateUsingTimeZone(country, false), interval = momentStartDate.diff(today, 'days'), isPastDay = false;
		if (interval < 0) {
			isPastDay = true;
		}
		return (
			<Layout>
				<Header color={PRIMARY_COLOR} backgroundColor="#F7F7F7" logo={logo} siteName={siteName} />
				<div>
					<Table width="100%" >
						<TBody>
							<TR>
								<TD style={textStyle}>
									<EmptySpace height={20} />
									<div>
										Hola {guestName},
									</div>
									<EmptySpace height={20} />
									<div>
										Lamentamos informarle que su Anfitrión {hostName} lamentablemente ha cancelado su reserva
										{' '}{confirmationCode} at {listTitle} {isPastDay ? 'started' : 'starting'} en {checkInDate}.
										{
											refundToGuest > 0 && <span>
												{' '}Según la política de cancelación se le reembolsará <CurrencyView amount={refundToGuest} currency={currency} /> y se le notificará.
											</span>
										}

									</div>
									<EmptySpace height={40} />
									<EmailSignature siteName={siteName} />
								</TD>
							</TR>
						</TBody>
					</Table>
					<EmptySpace height={40} />
				</div>
				<Footer siteName={siteName} />
				<EmptySpace height={20} />
			</Layout>
		);
	}
}

export default CancelledByHost;
